<template>
  <router-view />
</template>
<script>
//import axios from 'axios';
export default {
  name: 'App',
  data() {
    return {};
  },
  methods: {
    // async getCurrentDateTime() {
    //   let that = this;
    //   await axios
    //     .get('/CLC/Session/GetCurrentDateTime')
    //     .then((response) => {
    //       /* eslint-disable */
    //       that.$store.state.currentDateTime = new persianDate(
    //         new Date(response.data)
    //       ).format('lt');
    //       that.$store.state.currentGregorianDateTime = new Date(response.data);
    //     })
    //     .catch(() => {});
    // },
  },
  async beforeMount() {
    // await this.getCurrentDateTime();
    // await setInterval(() => {
    //   this.getCurrentDateTime();
    // }, 60000);
  },
};
</script>
<style>
/* #app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
} */
</style>
